import { createContext } from "react";

const UserContext = createContext(false);

export default UserContext;
